import { Component, OnInit } from '@angular/core';
import { Contrato } from '../../../domain/contrato.model';
import { ActivatedRoute, Params } from '@angular/router';
import { ContratoService } from '../../../services/contrato.service';
import { ReturnAPI } from '../../../domain/return-api.model';

@Component({
  selector: 'app-contratos-a-cancelar-detail',
  templateUrl: './contratos-a-cancelar-detail.component.html',
  styleUrls: ['./contratos-a-cancelar-detail.component.css'],
})
export class ContratosACancelarDetailComponent implements OnInit {
  contratoID: number;
  contrato: Contrato;

  constructor(private route: ActivatedRoute, private contratoService: ContratoService) {
    this.route.params.subscribe((params: Params) => {
      this.contratoID = params.id;
    });
  }

  ngOnInit(): void {
    this.contratoService.findOne(this.contratoID).subscribe((response: ReturnAPI<Contrato>) => {
      if (response.success) {
        this.contrato = response.object;
      }
    });
  }
}
